import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getDiscordSDK } from '../../utils/discord';
import type { DiscordAuth } from '../../types';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api' }),
  tagTypes: ['Auth'],
  endpoints: (builder) => ({
    // Complete Discord authentication flow
    authenticateWithDiscord: builder.mutation<{
      auth: DiscordAuth;
    }, void>({
      queryFn: async () => {
        try {
          console.log('🔄 authenticateWithDiscord mutation called');
          const discordSdk = getDiscordSDK();

          console.log('🔄 Discord SDK instance:', discordSdk);
          if (!discordSdk) {
            throw new Error('Discord SDK not ready');
          }

          console.log('🔄 window.CLIENT_ID:', window.CLIENT_ID);
          if (!window.CLIENT_ID) {
            throw new Error('CLIENT_ID not found');
          }

          // Step 1: Get authorization code from Discord
          console.log('🔄 Calling authorize with client_iddddddddddddddddddd:', window.CLIENT_ID);
          const { code } = await discordSdk.commands.authorize({
            client_id: window.CLIENT_ID,
            response_type: 'code',
            state: '',
            prompt: 'none',
            scope: ['identify', 'guilds', 'guilds.members.read'],
          });
          console.log('✅ Authorization successful, got code');

          // Step 2: Exchange code for token via our API
          console.log('🔄 Exchanging code for token...');
          const response = await fetch('/api/token', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ code }),
          });

          if (!response.ok) {
            const errorText = await response.text();
            console.error('❌ Error response:', errorText);
            throw new Error(`Failed to get access token: ${response.statusText}`);
          }

          const tokenData: { access_token: string } = await response.json();
          console.log('✅ Token exchange successful');

          // Step 3: Authenticate with Discord SDK using the token
          console.log('🔄 Authenticating with Discord SDK...');
          const auth = await discordSdk.commands.authenticate({
            access_token: tokenData.access_token,
          });

          if (!auth) {
            console.error('❌ Authentication returned null');
            throw new Error('Authentication failed');
          }

          console.log('✅ Authentication successful');

          return {
            data: {
              auth: auth as DiscordAuth,
            },
          };
        } catch (error) {
          console.error('❌ authenticateWithDiscord error:', error);
          return {
            error: {
              status: 'CUSTOM_ERROR' as const,
              error: error instanceof Error ? error.message : 'Authentication failed',
            },
          };
        }
      },
      invalidatesTags: ['Auth'],
    }),
  }),
});

export const { useAuthenticateWithDiscordMutation } = authApi;
